import { render } from "./ScrollToBottomButton.vue?vue&type=template&id=ce974a6c&scoped=true"
import script from "./ScrollToBottomButton.vue?vue&type=script&lang=js"
export * from "./ScrollToBottomButton.vue?vue&type=script&lang=js"

import "./ScrollToBottomButton.vue?vue&type=style&index=0&id=ce974a6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce974a6c"]])

export default __exports__